import { useEffect, useState } from 'react'
import { OrderPackage } from '../../../models/_models'

export const useSeniorOrderPackage = (orderPackageId, isSenior) => {
  const [orderPackage, setOrderPackage] = useState()

  const included = isSenior ? 'seniorImage' : 'pose'

  useEffect(() => {
    OrderPackage
      .includes([
        included,
        { apiOption: 'package' },
        {
          sheets: ['background', 'imageType', included],
          addonSheets: ['background', 'seniorImage', 'pose', 'addon'],
        },
      ])
      .find(orderPackageId)
      .then((res) => {
        setOrderPackage(res.data)
      })
  }, [orderPackageId])

  return orderPackage
}
